<template>
<v-layout align-center justify-center row fill-height>
    <v-card>
        <v-card-title>
            <span>Logged Out</span>
        </v-card-title>
        <v-card-title>
            <span>You have been successfully logged out.</span>
        </v-card-title>
        <v-btn @click="signIn()">
            Login
        </v-btn> 
    </v-card>
</v-layout>
</template>

<script>
import auth from '@/services/auth';

export default {
    components: {

    },
    data() {
        return {
            show: true
        };
    },
    methods: {
        signIn() {
            auth.signIn();
        }
    }
};
</script>